<template>
<div>
  <div class="view-header">
    <h1>{{$store.state.meta.title}}</h1>
    <div class="func-list">
      <el-button type="primary" plain @click="onExport">项目报告导出</el-button>
    </div>
  </div>

  <div class="view-filter">
    <el-form :inline="true" :model="filterForm" size="small" label-suffix=":">
      <el-form-item label="授权产品">
        <el-select v-model="filterForm.goods_name" placeholder="授权产品">
          <el-option
            v-for="item in goodsList"
            :key="item.goods_id"
            :label="item.goods_name"
            :value="item.goods_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="filterForm.find_value" placeholder="请输入姓名/手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" plain @click="onSearch">查找</el-button>
      </el-form-item>
    </el-form>
  </div>

  <div class="table">
    <el-table
      size="medium"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="user_name"
        label="授权人姓名"
        width="180">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        width="160">
      </el-table-column>
      <el-table-column
        prop="goods_name"
        label="授权产品">
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="授权日期"
        width="160">
      </el-table-column>
      <el-table-column
        label="授权状态">
        <template slot-scope="scope">
          {{['过期','有效'][scope.row.status]}}
        </template>
      </el-table-column>
      <el-table-column
        label="剩余时间">
        <template slot-scope="scope">
          {{scope.row.diffTime}}
        </template>
      </el-table-column>
      <el-table-column
        prop="template_num"
        label="项目模版数">
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click.prevent.stop="toDetail(scope.row)">
            查看项目报告
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div class="pagination">
    <el-pagination
      :hide-on-single-page="totalPage<2"
      background
      layout="prev, pager, next, jumper"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="20"
      :total="totalCount">
    </el-pagination>
  </div>
</div>
</template>

<script>
import moment from 'moment';
import { getGoodsList } from '@/api/common';
import { empowerList } from '@/api';

function getTime(list) {
  for (const item of list) {
    if (item.status === 1) {
      // const createTime = moment(item.create_time);
      const lastTime = moment(item.update_time);
      const diffSec = lastTime.diff(moment(), 'seconds');
      const timeString = diffSec < 0 ? 0 : timeStamp(diffSec);


      function timeStamp(second_time) {
        let time = `${parseInt(second_time)}秒`;
        if (parseInt(second_time) > 60) {
          const second = parseInt(second_time) % 60;
          let min = parseInt(second_time / 60);
          time = `${min}分${second}秒`;

          if (min > 60) {
            min = parseInt(second_time / 60) % 60;
            let hour = parseInt(parseInt(second_time / 60) / 60);
            time = `${hour}小时${min}分${second}秒`;

            if (hour > 24) {
              hour = parseInt(parseInt(second_time / 60) / 60) % 24;
              const day = parseInt(parseInt(parseInt(second_time / 60) / 60) / 24);
              time = `${day}天${hour}小时${min}分${second}秒`;
            }
          }
        }

        return time;
      }
      item.diffTime = timeString;
    } else {
      item.diffTime = 0;
    }
  }
  return list;
}
export default {
  name: 'Page',
  data: () => ({
    filterForm: {
      goods_name: '',
      find_value: '',
    },
    list: [],
    totalCount: 0,
    totalPage: 1,
    currentPage: 0,
    goodsList: [],
  }),
  created() {
    getGoodsList().then((res) => {
      if (res.status === 0) {
        const { data } = res;
        const goodsList = [{
          goods_name: '全部产品',
          goods_id: '',
        }];

        for (const item of data) {
          goodsList.push({
            goods_name: item.goods_name,
            goods_id: item.goods_name,
          });
        }
        this.goodsList = goodsList;
      } else {
        this.goodsList = [];
      }
    });
    this._getList(1);
  },
  methods: {
    _getList(page) {
      const filterForm = { ...this.filterForm };
      filterForm.page = page;
      empowerList(filterForm).then((res) => {
        if (res.status === 0) {
          const { data } = res;
          this.totalCount = data.totalCount;
          this.totalPage = data.totalPage;
          this.currentPage = parseInt(data.currentPage);
          let { list } = data;
          list = getTime(list);
          this.list = list;
          // setInterval(() => {
          //   this.list = getTime(this.list);
          // }, 1000);
        } else {
          this.list = [];
          this.totalCount = 0;
          this.totalPage = 1;
          this.currentPage = 0;
        }
      });
    },
    onSearch() {
      this._getList(1);
    },
    handleCurrentChange(val) {
      this._getList(val);
    },
    toDetail({ user_id }) {
      this.$router.windowOpen({ name: 'templateList', params: { user_id } });
    },
    onExport() {
      this.$router.windowOpen({
        name: 'reportExport',
        params: { user_id: '-1', template_id: '-1' },
      });
    },
  },
};
</script>

<style scoped>

</style>
